import Papa, { type ParseLocalConfig } from "papaparse"

interface CsvRowData {
	label: string
	latitude: number
	longitude: number
}

interface ImportAssetsFromCsvConfig {
	onSuccess: (data: CsvRowData[]) => void
	onError: ParseLocalConfig<CsvRowData, File>["error"]
}

const requiredCsvHeaders = ["label", "latitude", "longitude"]

export const importAssetsFromCsv = (file: File, config: ImportAssetsFromCsvConfig) => {
	const { onSuccess, onError } = config

	Papa.parse<CsvRowData>(file, {
		header: true,
		dynamicTyping: true,
		error: onError,
		complete: (results) => {
			const headersFromCsv = new Set<string>(results.meta.fields ?? [])

			for (const requiredHeader of requiredCsvHeaders) {
				if (!headersFromCsv.has(requiredHeader)) {
					onError?.(new Error(`Missing required header: ${requiredHeader}`), file)
					return
				}
			}

			// TODO: zod schema to validate
			for (const [index, row] of results.data.entries()) {
				const { latitude, longitude } = row

				// latitude and longitude are required as of now
				if (latitude === null) {
					onError?.(new Error(`Missing latitude at row ${index + 1}`), file)
					return
				}

				if (longitude === null) {
					onError?.(new Error(`Missing longitude at row ${index + 1}`), file)
					return
				}
			}

			onSuccess(results.data)
		},
	})
}
